import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { setDemoMode, setDemoCookies, setDemoLocalStorage } from '../../utils/demoMode';
import './Auth.css';

function MainPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleTryDemo = () => {
    setDemoMode(true);
    setDemoCookies();
    setDemoLocalStorage();
    // Full reload so index.tsx installs the fetch interceptor
    window.location.href = '/dashboard';
  };

  return (
    <div className="main-page">
      <div className="main-page__card">
        <h1 className="main-page__title">Smarteaming</h1>
        <p className="main-page__subtitle">{t('Sign in or create an account to get started.')}</p>
        <div className="main-page__actions">
          <button
            type="button"
            className="main-page__btn main-page__btn--primary"
            onClick={() => navigate('/signin')}
          >
            {t('Sign In')}
          </button>
          <button
            type="button"
            className="main-page__btn main-page__btn--secondary"
            onClick={() => navigate('/signup')}
          >
            {t('Sign Up')}
          </button>
        </div>
        <button type="button" className="main-page__demo-link" onClick={handleTryDemo}>
          {t('Try a live demo')} →
        </button>
      </div>
    </div>
  );
}

export default MainPage;
